import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationModalService {
  public events: {
    accept: Subject<void>;
    reject: Subject<void>;
    show: Subject<void>;
    hide: Subject<void>;
  } = {
    accept: new Subject<void>(),
    reject: new Subject<void>(),
    show: new Subject<void>(),
    hide: new Subject<void>(),
  };

  public message: any;

  show(options: { message: any; accept: any; reject: any }) {
    this.message = options.message;
    this.events.show.next();

    this.events.accept.pipe(takeUntil(this.events.hide)).subscribe(() => {
      options.accept();
      this.events.hide.next();
    });

    this.events.reject.pipe(takeUntil(this.events.hide)).subscribe(() => {
      options.reject();
      this.events.hide.next();
    });
  }

  accept() {
    this.events.accept.next();
  }

  reject() {
    this.events.reject.next();
  }

  hide() {
    this.events.hide.next();
  }
}
